<mat-card>
    <mat-card-header>
        <mat-card-title><mat-icon>calendar_month</mat-icon> {{ selectedDate }}</mat-card-title>
        <button  mat-raised-button color="primary" (click)="createMatch()" tabindex="-1"><mat-icon>add_box</mat-icon>Create Match</button>
    </mat-card-header>
    <mat-card-content>
        <p *ngIf="matches.length == 0">- No matches have been created for this date -</p>
        <mat-tab-group [selectedIndex]="selectedIndex">
            <mat-tab *ngFor="let match of matches; let i = index" [label]="(i + 1) + '.'">
                <form [formGroup]="match">
                    <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                        <mat-label>Competition</mat-label>
                        <mat-select formControlName="competitionControl" (selectionChange)="changeCompetition(i)">
                            <mat-select-trigger>
                                <ng-container *ngIf="getSelectedCompetition(match.controls['competitionControl'].value) as competition">
                                    <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                                </ng-container>
                            </mat-select-trigger>
                            <ng-container *ngFor="let competition of competitions">
                                <mat-option [value]="competition.uid">
                                    <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                        <mat-label>Team A</mat-label>
                        <mat-select formControlName="teamAControl" (selectionChange)="changeTeamA(i)">
                            <mat-select-trigger>
                                <ng-container *ngIf="getSelectedTeam(match.controls['teamAControl'].value) as team">
                                    <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                                </ng-container>
                            </mat-select-trigger>
                            <ng-container *ngFor="let team of teams">
                                <mat-option *ngIf="team.competition == match.controls['competitionControl'].value" [value]="team.uid">
                                    <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                        <mat-label>Team B</mat-label>
                        <mat-select formControlName="teamBControl" (selectionChange)="changeTeamB(i)">
                            <mat-select-trigger>
                                <ng-container *ngIf="getSelectedTeam(match.controls['teamBControl'].value) as team">
                                    <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                                </ng-container>
                            </mat-select-trigger>
                            <ng-container *ngFor="let team of teams">
                                <mat-option *ngIf="team.competition == match.controls['competitionControl'].value" [value]="team.uid">
                                    <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                        <mat-label>Veto</mat-label>
                        <mat-select formControlName="vetoControl" (selectionChange)="changeVeto(i)">
                            <mat-option value="">- None -</mat-option>
                            <ng-container *ngFor="let veto of vetos">                                    
                                <mat-option *ngIf="veto.competition == match.controls['competitionControl'].value" [value]="veto.uid">
                                    {{ veto.date }} | {{ getTeamTricode(veto.teamOne) }} vs {{ getTeamTricode(veto.teamTwo) }} ({{ veto.lobbyCode }})
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </form>
                <mat-card-actions>
                    <button mat-raised-button color="warn" *ngIf="!isDeleteMatch" tabindex="-1" (click)="deleteMatch(i)"><mat-icon>delete_outline</mat-icon>Delete Match</button>
                    <button mat-raised-button *ngIf="isDeleteMatch" tabindex="-1" disabled><mat-spinner></mat-spinner></button>
                </mat-card-actions>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>